import {
   APPLICATION_TYPE, WATCHLIST_GRID_INDEX, MIN_SCRIPS_IN_WATCHLISTS, BUSINESS_LAYER_RESPONSE,
   MY_HOLDINGS_WATCHLIST_NAME, DONT_MISS_WATCHLIST_NAME, DEEP_LINK, COVER, LOCAL_STORAGE_KEYS
} from "../../utils/global_variables";
import {
   deepClone, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId,
   getMktSegIdFromMappedMktSegId, removeExpiriedScrip, convertDateToSeconds, filterObjects, arrangeObjectsInSequence,
   TripleDESDecrypt, TripleDESEncrypt, setEncryptLocalStorage, getDecryptLocalStorage, filterUsername, encryptTDES, isGuestUser, getStorageWithMultiTabCheck
} from '../../utils/global_functions';
import config from '../../config.json';
import { getAppSyncDetailsByUser, getScripbyTokenAndMktSegId, whatsHotData, createWatchList, updateWatchList } from "../../apis";
import { _getDontMiss } from "../dontMiss";
import { store } from "../../redux/store";
import { getUserDetials, userLogin } from "../../redux/actions/auth";




const systemDefinedWatchlists = [DONT_MISS_WATCHLIST_NAME, MY_HOLDINGS_WATCHLIST_NAME];


function _resetGridFeatures(GRID_REF, isResetSelection = false) {
   //This function is used to reset watchlist grid features to its orginal like reording , checkbox
   if (isResetSelection) {
      GRID_REF?.current?.api.forEachNode((node) => {
         node.setSelected(false);
      });
   } else { }

   GRID_REF?.current?.columnApi?.setColumnVisible(
      GRID_REF?.current?.columnApi?.columnModel?.columnDefs[0]?.colId,
      false
   );
   GRID_REF?.current?.api?.setGridOption('rowDrag', false);
   GRID_REF?.current?.api?.onFilterChanged();
}

function _isWatchlistSystemDefined(objActiveWatchlist) {
   /*This functions checkes for the selectedWatchlist [objActiveWatchlist] is a systemdefinedWatchlists or not*/
   //objActiveWatchlist contains the selected watchlist
   for (let i = 0; i < systemDefinedWatchlists.length; i++) {
      if (objActiveWatchlist?.sWatchListName?.toLowerCase() === systemDefinedWatchlists[i]) {
         return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, data: null };
      }
   }
   return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
}



function _handleSystemDefinedWatchlist(objWatchlist, strActionType) {

   /*objWatchlist ==> It contains single watchlist strActionTyp ==> holds what all actions you will be performing on watchlist */

   /*Prevents functionalities on system defined watchlists*/

   if (!_isWatchlistSystemDefined(objWatchlist)?.status) {
      switch (APPLICATION_TYPE) {
         case 'BREEZE': {
            switch (strActionType) {
               case 'REMOVE': {
                  return { status: false, message: 'Cannot remove scrips from system defined watchlists !', data: null };
               }
               case 'DEFAULT': {
                  return { status: false, message: 'System defined watchlists cannot set to be default !', data: null };
               }
               case 'MANAGE_COLUMNS': {
                  return { status: false, message: 'Cannot manage columns of system defined watchlists !', data: null };
               }
               case 'ADD': {
                  return { status: false, message: 'Cannot add scrips to defined watchlists !', data: null };
               }
               case 'REORDER': {
                  return { status: false, message: 'Cannot reorder scrips in  system defined watchlists !', data: null };
               }
               case 'RENAME': {
                  return { status: false, message: 'Cannot rename system defined watchlists !', data: null };
               }
               case 'DELETE': {
                  return { status: false, message: 'Cannot delete system defined watchlists !', data: null };
               }
               default:
                  break;
            }
            break;
         }
         default:
            break;
      }
   } else {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
   }
}


function _watchlistNameAlreadyExist(arrWatchlist, strWatchlistName) {
   /*this function checks for Watchlist name already exists in user watchlists */
   // arrWatchlist ==> containes the watchlists of user
   // strWatchlistName==> contains the name given by the user
   let obj = { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };

   if (arrWatchlist.length) {
      for (let i = 0; i < arrWatchlist.length; i++) {
         if (arrWatchlist[i].sWatchListName?.toLowerCase() === strWatchlistName?.toLowerCase()) {
            obj = { status: false, message: 'Watchlist name already exists !', data: null };
            break;
         }
      }
      return obj;
   }
   return obj;
}

function _emptyWatchlist(objWatchlist) {
   /*this function checks for the given Watchlist scrips is empty */
   /*objWatchlist ==> is a single watchlist from broker defined watchlists*/
   if (objWatchlist?.scrips?.length < 0 || objWatchlist?.scrips === null) {
      return { status: false, message: `'${objWatchlist?.sWatchListName}' has no scrips !`, data: null };
   } else if (objWatchlist?.scrips?.length > 0) {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
   } else {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
   }
}


function _allWatchlistOpened(arrWatchlist, arrOpenWatchlist) {
   /*when all the watchlists present for user are opened, this function prevents user from  adding more watchlists to tabs*/
   // arrWatchlist ==> containes the watchlists of user
   // arrOpenWatchlists ==> contains the opened watchlists in tabs
   if (arrWatchlist.length === arrOpenWatchlist.length) {
      return { status: false, message: 'No more watchlists to add in tab !', data: null };
   } else {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
   }
}

function _creatingCustomWatchlist(arrWatchlist, strWatchlistName, arrGlobalWatchlists, maxWatchlist) {
   /*this function checks for the validation of the user watchlist name while creating to avoid renaming , restricing to create more than user allowed watchlists and empty naming convention*/
   // arrWatchlist ==> contains watchlists of user
   // strWatchlistName ==> this the custom watchlist name given by the user to create watchlists name with custom watchlist name
   // arrGlobalWatchlists ==> contains broker defined watchlists
   //  maxWatchlist ==> contains the number of watchlists user is allowed to creat3e
   const objExistingWatchlist = _watchlistNameAlreadyExist(arrWatchlist, strWatchlistName);
   const arrFilteredWatchlist = arrWatchlist?.length ? arrWatchlist?.filter(eachWatchlist => eachWatchlist?.sWatchListName?.toLowerCase() !== DONT_MISS_WATCHLIST_NAME && eachWatchlist?.sWatchListName?.toLowerCase() !== MY_HOLDINGS_WATCHLIST_NAME) : [];
   const objExistingTopPicksWatchlist = arrGlobalWatchlists?.length ? arrGlobalWatchlists?.find((each) => each?.sWatchListName?.toLowerCase() === strWatchlistName?.toLowerCase()) : false;
   // objExistingWatchlist ==> checks for Watchlist name already exists in user watchlists
   // arrFilteredWatchlist ==> contains watchlits of user except system defined watchlists
   // objExistingTopPicksWatchlist ==> contains a bolean value checks that the strWatchlistname give by user is existing in broker defined watchlist


   if (!strWatchlistName) {
      return { status: false, message: 'Watchlist name should not be empty !', data: null };
   } else if (arrFilteredWatchlist?.length >= maxWatchlist) {
      return { status: false, message: `Exceeded  watchlists limit ${maxWatchlist} !`, data: null };
   } else if (!objExistingWatchlist.status || objExistingTopPicksWatchlist) {
      return { status: false, message: 'Watchlist name already exists !', data: null };
   } else {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
   }

}

function _checkForSpecialChars(value) {
   /*This function checkes for special characters which are not allowed in watchlist name */
   //value ==> containes the string value which is the watchlist name givien by user
   const alphaNumericCharacters = /^[a-zA-Z0-9]*$/;
   if (alphaNumericCharacters.test(value)) {

      return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
   } else {

      return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
   }
}

function _checWatchlistExist(arrWatchlists, objSelectedWatchlist) {
   /*This function is used check the selected watchlits exists in the watchlitsts of user*/
   //arrWatchlists ==> contains the watchlists of user
   //objSelectedWatchlist ==> contains the selected watchlist

   let result;
   for (let i = 0; i < arrWatchlists.length; i++) {
      if (arrWatchlists[i].id === objSelectedWatchlist.id) {
         result = { status: false, message: `Watchlist ${objSelectedWatchlist?.sWatchListName} already exists `, data: null };
         break;
      } else {
         result = { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
      }
   }
   return result;
}

function _filterWatchlistForSystemDefined(arrWatchlist, arrSystemDefinedWatchlist = systemDefinedWatchlists) {
   /*This function gives the watchlits by filtering out the system defined watchlits */
   //arrWatchlist ==>contains the watchlists of user
   //arrSystemDefinedWatchlist ==> contains the ids of system definedWatchlists

   let filteredWatchlist = [];
   for (let i = 0; i < arrWatchlist.length; i++) {
      let found = false;
      for (let j = 0; j < arrSystemDefinedWatchlist.length; j++) {
         if (arrWatchlist[i]?.sWatchListName?.toLowerCase() === arrSystemDefinedWatchlist[j]) {
            found = true;
            break;
         }
      }
      if (!found) {
         filteredWatchlist.push(arrWatchlist[i]);
      }
   }
   return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { filteredWatchlist } };
}

function _addingGlobalWatchlist(arrWatchList, objSelectedWatchlist, bisWatchlistPresent, selectedScrips) {

   /*This function used to add watchlist of broker defined watchlists to users watchlits */
   // arrWatchList ==> watchlists of user
   // objSelectedWatchlist ==> selected watchlsit from top picks watchlists
   //  bisWatchlistPresent ==>givens the boolean value by giving the presence of watchlist for logged in user
   //  selectedScrips ==> scrips of the topicks selected watchlist

   let objWatchlistExisting = _checWatchlistExist(arrWatchList, objSelectedWatchlist);

   if (!objWatchlistExisting.status) {
      return { status: false, message: `Watchlist ${objSelectedWatchlist?.sWatchListName} already exists !`, data: null };
   } else {
      if (objSelectedWatchlist && Object.keys(objSelectedWatchlist).length > 0) {
         objSelectedWatchlist['bIsDefault'] = false;

         const arrScripsForAddWatchlist = selectedScrips?.map((scrip, i) => ({
            nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
            nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
            nSequenceNo: i + 1,
            sSettings: null
         }));
         objSelectedWatchlist['scrips'] = arrScripsForAddWatchlist;
         return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objSelectedWatchlist } };
      }
   }
}




function _renamingGlobalWatchlist(arrWatchList, objSelectedWatchlist, bisWatchlistPresent, selectedScrips, strRenamedWatchlistName) {
   // this fucntion is used to rename the system defined watchlists and give as  a new watchlsit if user selects any of the top picks watchlists
   // arrWatchList ==> watchlists of user
   // objSelectedWatchlist ==> selected system defined watchlist by user
   //  bisWatchlistPresent ==> givens the boolean value by giving the presence of watchlist for logged in user
   //  selectedScrips ==> scrips that are not unchecked while selecting broker defined watchlists
   //  strRenamedWatchlistName ==>watchlist renamed name of the slected watchlist from system defiend watchlists

   let objWatchlistExisting = _checWatchlistExist(arrWatchList, objSelectedWatchlist);

   if (!objWatchlistExisting.status) {
      return { status: false, message: `Watchlist ${objSelectedWatchlist?.sWatchListName} already exists `, data: null };
   } else {
      if (objSelectedWatchlist && Object.keys(objSelectedWatchlist).length > 0) {
         objSelectedWatchlist['sWatchListName'] = strRenamedWatchlistName?.toUpperCase();
         objSelectedWatchlist['bIsDefault'] = bisWatchlistPresent && _filterWatchlistForSystemDefined(arrWatchList, systemDefinedWatchlists)?.data?.filteredWatchlist?.length === 0 ? true : false;
         const arrScripsForAddWatchlist = selectedScrips?.map((scrip, i) => ({
            nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
            nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
            nSequenceNo: i + 1,
            sSettings: null
         }));

         objSelectedWatchlist['scrips'] = arrScripsForAddWatchlist;
         return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objSelectedWatchlist } };
      }
   }
}

function _removeSelectedScripts(objActiveWatchlist, arrActiveWatchlistScrips, arrSelectedScrips) {

   /*Remove Selected Scrips*/
   // This function is used to remove selected scrips from activeWatchlist
   //objActiveWatchlist==>  is the activeWatchlist
   //arrActiveWatchlistScrips ==> has the copies of activeWatchlist scrips
   //arrSelectedScrips ==> will have selected scrips from activeWatchlist scrips

   if (arrActiveWatchlistScrips?.length === arrSelectedScrips?.length) {
      return { status: false, message: `Remove ${arrSelectedScrips?.length} scrips from  ${objActiveWatchlist?.sWatchListName}`, data: {} };
   } else {
      for (let j = 0; j < arrSelectedScrips?.length; j++) {
         let nIndex = arrActiveWatchlistScrips?.findIndex(elem => elem[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrSelectedScrips[j][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
         if (nIndex >= 0) {
            arrActiveWatchlistScrips.splice(nIndex, 1);
         } else {
         }
      }

      let arrAllWatchlistScripsWithGridIndexCopy = arrActiveWatchlistScrips;
      arrActiveWatchlistScrips?.forEach((eachScrip, indexOfEachScrip) => {
         if (!removeExpiriedScrip(eachScrip[WATCHLIST_GRID_INDEX?.EXPIRYDATE])) {
            arrAllWatchlistScripsWithGridIndexCopy?.splice(indexOfEachScrip, 1);
            //removing expired scrips here
         } else {

            // not removing expired scrips
         }
      });

      let arrScrips = arrAllWatchlistScripsWithGridIndexCopy?.map((scrip, i) => ({
         nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
         nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
         nSequenceNo: i + 1,
         sSettings: null
      }));
      objActiveWatchlist['scrips'] = arrScrips;
      return { status: true, message: `Remove ${arrSelectedScrips?.length} scrips from  ${objActiveWatchlist?.sWatchListName}`, data: { objActiveWatchlist } };
   }
}

function _createAndAddScripsInWatchlist(arrWatchlist, arrScripsToBeAdded, strCustomNewWatchlistName, bIsWatchlistPresent, scripsAllowedPerWatchlist, userId) {

   /*this function is used to  Creating custom watchlist */
   // arrWatchlist ===> watchlist of user
   // arrScripsToBeAdded ==> scrips that user addded while creating custom watchlist
   //  strCustomNewWatchlistName => name to watchlist given by the user
   //  bIsWatchlistPresent ==> boolean value that has the presene of wathclist of user
   //  appInfo ==> will have info of user and breeze app
   //  userId ==> what ever the user is loged with in will have the userid


   if (arrScripsToBeAdded.length < MIN_SCRIPS_IN_WATCHLISTS) {
      return { status: false, message: `Add atleast ${MIN_SCRIPS_IN_WATCHLISTS} scrip should be added`, data: null };
   }
   else if (arrScripsToBeAdded.length > scripsAllowedPerWatchlist) {
      return { status: false, message: `Cannot add more than ${scripsAllowedPerWatchlist} scrips`, data: null };
   } else {

      const objWatchlistPayload = {
         sWatchListName: strCustomNewWatchlistName?.toUpperCase(),
         bIsPrivate: true,// AMEERSHA N this will be true if user creates anyWatchlist by user
         bIsDefault: false,
         sUserId: userId,
         sTenantId: config.TenantId,
         scrips: arrScripsToBeAdded?.map((scrip, i) => ({
            nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
            nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
            nSequenceNo: i + 1,
            sSettings: null
         })),
         sSettings: null
      };
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objWatchlistPayload } };
   }
}

async function _getAppDetailsByUser() {
   try {
      const objResp = await getAppSyncDetailsByUser();
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objResp: objResp?.data } };
   } catch (error) {

      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}


async function _getWhatsHotData() {
   try {
      const objResp = await whatsHotData();
      return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp };
   } catch (error) {
      return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
   }

}

async function _updateWatchlistandSetDefault(watchLists, arrTopRecommendationData, arrSortedHoldingsScrips, objLoginSession) {
   // this function is used to load watchlist of user on load or reload wth defaulltwatchlist,watchlists,openwatchlist and active watchlists
   //watchLists ==> will have the watchlsit resp of user
   try {
      let recommendationCopy = [...arrTopRecommendationData];
      const arrRecommendations = recommendationCopy?.length > 0 && recommendationCopy?.map((element) => ({
         mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(element?.nMarketSegmentId)),
         token: element?.nToken
      }));
      let arrAllWatchlistScrips = watchLists?.map((watchlist) => [...watchlist?.scrips]).flat();

      arrAllWatchlistScrips = arrAllWatchlistScrips?.map((scrip) => (
         { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
      ));
      if (arrRecommendations?.length > 0) {
         arrAllWatchlistScrips = [...arrAllWatchlistScrips, ...arrRecommendations];
      } else { }
      const objScripsResp = await _getScripsInfo(arrAllWatchlistScrips);
      const alphabeticallyseq = objScripsResp?.data?.objScripsResp?.result?.sort((a, b) => a?.sSymbol?.localeCompare(b?.sSymbol));
      const arrAllWatchlistScripsWithGridIndex = convertScripResponseWatchlistGrid(alphabeticallyseq);
      const arrRecomendationScripWithIndexes = [];
      const arrAllWatchlistScripsWithGridIndexCopy = [];
      arrAllWatchlistScripsWithGridIndex?.forEach((eachScrip) => {
         if (removeExpiriedScrip(convertDateToSeconds(eachScrip[WATCHLIST_GRID_INDEX?.EXPIRYDATE]))) {
            const nRecommIndex = recommendationCopy?.findIndex(obj => obj?.nMarketSegmentId === eachScrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] && obj?.nToken === eachScrip[WATCHLIST_GRID_INDEX.TOKEN]);
            if (nRecommIndex >= 0) {
               arrRecomendationScripWithIndexes.push(eachScrip);
            } else { }
            arrAllWatchlistScripsWithGridIndexCopy.push(eachScrip);
            //removing expired scrips here
         } else { }
      });
      const objRecommendationsData = { arrRecommendationScrips: arrRecomendationScripWithIndexes, arrRecommendationInfo: recommendationCopy };

      let expiredScripsCount = 0;

      const arrUpdatedWatchlist = watchLists.map(watchlist => {
         expiredScripsCount = expiredScripsCount + watchlist?.scrips?.length;
         for (let i = 0; i < watchlist.scrips.length; i++) {
            const nIndex = arrAllWatchlistScripsWithGridIndexCopy.findIndex(elem => elem[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] === watchlist.scrips[i].nMarketSegmentId && elem[WATCHLIST_GRID_INDEX.TOKEN] === watchlist.scrips[i].nToken);

            if (nIndex >= 0) {
               watchlist.scrips[i] = arrAllWatchlistScripsWithGridIndexCopy[nIndex];
            } else {
               // TEMP for not having mapped seg for all scrips - start
               const nMktSegTokenIndex = arrAllWatchlistScripsWithGridIndexCopy.findIndex(elem => elem[WATCHLIST_GRID_INDEX.SEGMENT_ID] === watchlist.scrips[i].nMarketSegmentId && elem[WATCHLIST_GRID_INDEX.TOKEN] === watchlist.scrips[i].nToken);
               if (nMktSegTokenIndex >= 0) {
                  watchlist.scrips[i] = arrAllWatchlistScripsWithGridIndexCopy[nMktSegTokenIndex];
               } else {
               }
               // TEMP for not having mapped seg for all scrips - end
            }
         }
         return watchlist;
      });

      arrUpdatedWatchlist?.forEach((eachWatchlist) => {
         const filterdScrips = eachWatchlist?.scrips?.filter(filterObjects);
         eachWatchlist.scrips = filterdScrips;
         expiredScripsCount = expiredScripsCount - eachWatchlist.scrips?.length;
      });




      const objWhatsHotData = await _getWhatsHotData();
      const whatsHotData = objWhatsHotData?.data?.data?.result;
      const objRespDontMiss = await _getDontMiss(arrUpdatedWatchlist, objWhatsHotData?.data?.data?.result, objRecommendationsData);
      //Ameersha N - Breeze --BT-95888 Create Watchlist --Sorting dont miss scrips -Start * Do not remove this code *
      const sortedDontMissScrips = objRespDontMiss?.data?.allDontMissScrips.sort((a, b) => a[WATCHLIST_GRID_INDEX.SYMBOL].localeCompare(b[WATCHLIST_GRID_INDEX.SYMBOL]));
      const allDontMissScrips = sortedDontMissScrips;
      //Ameersha N - Breeze --BT-95888 Create Watchlist --Sorting dont miss scrips -End * Do not remove this code *

      const defaulltwatchlist = arrUpdatedWatchlist?.find(eachWatchlist => eachWatchlist?.bIsDefault);

      //for guest user we are not creating my holdings watchlist and dont miss will be setdefault and will be loaded on load
      // const isGuestUser = Object?.keys(objLoginSession)?.includes('guestMode');
      if (isGuestUser()) {
      } else {
         // finding my holdings watchlist
         let nHoldingsWatchlistIndex = arrUpdatedWatchlist?.findIndex((eachWatchlist) => (eachWatchlist?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME));
         if (nHoldingsWatchlistIndex <= -1) {

            const objHoldingsWatchlistPayload = {
               bIsDefault: defaulltwatchlist === undefined && arrUpdatedWatchlist?.length <= 0 ? true : false,
               bIsPrivate: false,
               sSettings: null,
               sUserId: arrUpdatedWatchlist[0]?.sUserId,
               sWatchListName: MY_HOLDINGS_WATCHLIST_NAME?.toUpperCase(),
               scrips: [],
               sTenantId: config?.TenantId
            };
            const objWatchlist = await _createWatchlist(objHoldingsWatchlistPayload);
            if (objWatchlist?.status) {

               const { objWatchlistResp } = objWatchlist?.data;
               objWatchlistResp['scrips'] = arrSortedHoldingsScrips; // sorted holdings scrips should be added
               arrUpdatedWatchlist?.push(objWatchlistResp);
            } else { }
         } else if (nHoldingsWatchlistIndex >= 0) {
            // found means take that watchlist assign holdings scrips and reassign at that particular index
            let matchedHoldingsWatchlist = arrUpdatedWatchlist[nHoldingsWatchlistIndex];
            matchedHoldingsWatchlist['scrips'] = arrSortedHoldingsScrips;                   // sorted scrips are importnant
            arrUpdatedWatchlist[nHoldingsWatchlistIndex] = matchedHoldingsWatchlist;
         } else { }
      }





      //allDontMissScrips// contains dont miss scrips after api success this should be pushed to dont miss wathclist
      let nDontMissWatchlistIndex = arrUpdatedWatchlist?.findIndex((eachWatchlist) => (eachWatchlist?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME));
      if (nDontMissWatchlistIndex <= -1) {

         const objDontMissWatchlist = {
            bIsDefault: isGuestUser ? true : false,
            bIsPrivate: false,
            sSettings: null,
            sUserId: arrUpdatedWatchlist[0]?.sUserId,
            sWatchListName: 'DONTMISS',
            scrips: [],
            sTenantId: config?.TenantId
         };
         const objWatchlist = await _createWatchlist(objDontMissWatchlist);
         if (objWatchlist?.status) {


            const { objWatchlistResp } = objWatchlist?.data;
            objWatchlistResp['scrips'] = allDontMissScrips; // sorted dont miss scrips should be added
            arrUpdatedWatchlist?.push(objWatchlistResp);
         } else { }
      } else if (nDontMissWatchlistIndex >= 0) {

         let objMatchedDontMissWatchlist = arrUpdatedWatchlist[nDontMissWatchlistIndex];
         objMatchedDontMissWatchlist['scrips'] = allDontMissScrips; // sorted scrips are importnant
         arrUpdatedWatchlist[nDontMissWatchlistIndex] = objMatchedDontMissWatchlist;
      } else { }

      // Find Default Watchlist

      let objDefaultWatchlist = arrUpdatedWatchlist?.find((watchlist) => watchlist.bIsDefault);
      if (!objDefaultWatchlist && arrUpdatedWatchlist?.length > 0) {
         objDefaultWatchlist = arrUpdatedWatchlist[0];
      }

      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objDefaultWatchlist, arrAllWatchlists: arrUpdatedWatchlist, allDontMissScrips, whatsHotData, arrRecomendationScripWithIndexes, arraAllDontMiss: objRespDontMiss?.data?.resultObject } };
   } catch (error) {
      console.error(error);

      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}



async function _getScripsInfo(allWatchlistScrips) {
   // this function is used to get scripsinfo of the selcted watchlist from broker defined watchlists
   //allWatchlistScrips ==> will have the selected watchlist  scrips from system defiend watchlists
   let objScripsResp;
   try {
      if (allWatchlistScrips?.length > 0) {
         objScripsResp = await getScripbyTokenAndMktSegId(allWatchlistScrips);
         objScripsResp = objScripsResp.data;
      } else {
         objScripsResp = [];
      }
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objScripsResp } };
   } catch (error) {
      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}



async function _getScrips(selectedGlobalWatchlist) {
   // this function is used to get scripsinfo of the selcted watchlist from broker defined watchlists
   //selectedGlobalWatchlist ==> will have the selected watchlist from global
   try {
      const arrClone = deepClone(selectedGlobalWatchlist);
      const arrScrips = arrClone?.scrips?.map((scrip) => (
         { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
      ));
      const objResp = await getScripbyTokenAndMktSegId(arrScrips);
      const arrConvertedScripsReponse = convertScripResponseWatchlistGrid(objResp?.data?.result);

      arrClone['scrips'] = arrConvertedScripsReponse;

      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { selectedGlobalWatchlistCopy: arrClone } };
   } catch (error) {

      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}


async function _createWatchlist(selectedWatchlist) {
   try {
      if (!isGuestUser()) {
         let objScripsResp;
         const objResp = await createWatchList(selectedWatchlist);
         const objWatchlistResp = objResp.data.data;
         const arrScrips = objResp.data.data?.scrips?.map((scrip) => (
            { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
         ));
         if (arrScrips?.length > 0) {
            objScripsResp = await getScripbyTokenAndMktSegId(arrScrips);
            objWatchlistResp['scrips'] = convertScripResponseWatchlistGrid(objScripsResp?.data?.result);

         } else {
            objScripsResp = [];
            objWatchlistResp['scrips'] = [];
         }
         return {
            status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objWatchlistResp, objResp }
         };
      } else {
         let objScripsResp;
         const objWatchlistResp = selectedWatchlist;
         const storedWatchlist = JSON.parse(getDecryptLocalStorage('GUEST_WATCHLIST'));
         objWatchlistResp['id'] = storedWatchlist ? storedWatchlist?.length + 1 : 1;
         if (storedWatchlist !== null) {
            storedWatchlist.push(selectedWatchlist);
            setEncryptLocalStorage('GUEST_WATCHLIST', JSON.stringify(storedWatchlist));
         } else {
            setEncryptLocalStorage('GUEST_WATCHLIST', JSON.stringify([objWatchlistResp]));
         }
         const arrScrips = selectedWatchlist?.scrips?.map((scrip) => (
            { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
         ));
         if (arrScrips?.length > 0) {
            objScripsResp = await getScripbyTokenAndMktSegId(arrScrips);
            objWatchlistResp['scrips'] = convertScripResponseWatchlistGrid(objScripsResp?.data?.result);
         } else {
            objScripsResp = [];
            objWatchlistResp['scrips'] = [];
         }
         return {
            status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { objWatchlistResp, selectedWatchlist }
         };
      }

   } catch (error) {
      console.log(error);
      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}


async function _updateCurrentWatchlist(selectedWatchlist, watchlists, openWatchlists) {
   // this fucntion willl update the activeWatchlist htat means selected watchlsit like adding, or removing scrips setdefault reorderinglike that

   // selectedWatchlist  ==> will have the selected watchlist user wanted to update
   //  watchlists ==> will have watchlists of user
   //  openWatchlists ==> will have the watchlists that are opened in tabs
   try {
      let objScripsResp = [];
      let objWatchlistResp;
      let objResp = {};
      // Maaz A - Start
      delete selectedWatchlist.createdAt;
      delete selectedWatchlist.updatedAt;
      delete selectedWatchlist._lastChangedAt;
      // Maaz A - End
      if (!isGuestUser()) {
         objResp = await updateWatchList(selectedWatchlist);
         objWatchlistResp = objResp.data.data;
         const arrScrips = objResp.data.data?.scrips?.map((scrip) => (
            { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
         ));

         if (arrScrips?.length > 0) {
            objScripsResp = await getScripbyTokenAndMktSegId(arrScrips);
            const sequenceArrangedScrips = await arrangeObjectsInSequence(objResp.data.data.scrips, objScripsResp?.data?.result);
            // await arrangeObjectsInSequence(objResp.data.data.scrips, objScripsResp?.data?.result); // keep this commented in case client wants scrip added to be seen in first row
            objWatchlistResp['scrips'] = convertScripResponseWatchlistGrid(sequenceArrangedScrips);
         } else {
            objScripsResp = [];
            objWatchlistResp['scrips'] = [];
         }
      } else {
         objWatchlistResp = selectedWatchlist;
         const arrScrips = selectedWatchlist?.scrips?.map((scrip) => (
            { mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scrip.nMarketSegmentId)), token: scrip.nToken, }
         ));
         if (arrScrips?.length > 0) {
            objScripsResp = await getScripbyTokenAndMktSegId(arrScrips);
            const sequenceArrangedScrips = await arrangeObjectsInSequence(selectedWatchlist?.scrips, objScripsResp?.data?.result)
            objWatchlistResp['scrips'] = convertScripResponseWatchlistGrid(sequenceArrangedScrips);
         } else {
            objScripsResp = [];
            objWatchlistResp['scrips'] = [];
         }
         const storedWatchlist = JSON.parse(getDecryptLocalStorage('GUEST_WATCHLIST'));
         const updatedWatchlist = storedWatchlist?.map(item => item?.id === objWatchlistResp?.id ? { ...item, scrips: objWatchlistResp?.scrips } : item);
         setEncryptLocalStorage('GUEST_WATCHLIST', JSON.stringify(updatedWatchlist));
      }

      const nWatchlistsIndex = watchlists.findIndex((elem) => elem.id === objWatchlistResp.id);
      const nOpenWatchlistsIndex = openWatchlists.findIndex((elem) => elem.id === objWatchlistResp.id);
      const ndontMissOpenWatchlistIndex = openWatchlists?.findIndex((watchlist) => watchlist?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME);
      //Empty dontmiss scrips and recreate again for delete and add scrips
      const ndontMissWatchlistIndex = watchlists?.findIndex((watchlist) => watchlist?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME);
      if (ndontMissWatchlistIndex >= 0) {
         watchlists[ndontMissWatchlistIndex].scrips = [];
      } else { }
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { nWatchlistsIndex, watchlists, nOpenWatchlistsIndex, ndontMissOpenWatchlistIndex, objWatchlistResp, objResp } };
   } catch (error) {
      console.log(error);
      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}



function _updatingWatchlist(watchlist, arrWatchlists, arrOpenWatchlists, objActiveWatchList) {

   // this fucntion returns the updated watchlists and openwatchlists and activeWatchlist after deleting an wathlist
   // watchlist  ==> will have the selected watchlist user wanted to delete
   //  arrWatchlists ==> will have watchlists of user
   //  arrOpenWatchlists ==> will have the watchlists that are opened in tabs
   // objActiveWatchList ==> will have the activeWatchlist in tabs

   try {
      const nIndexOpenWatchlists = arrOpenWatchlists.findIndex((obj) => {
         return obj.id === watchlist?.id;
      });

      if (arrOpenWatchlists.length > 0) {
         // If deleting watchlist and active watchlist is same
         if (watchlist?.id === objActiveWatchList.id) {
            // If deleteting watchlist at last index then active is first watchlist
            if (nIndexOpenWatchlists >= 0 && nIndexOpenWatchlists === arrOpenWatchlists.length - 1) {
               objActiveWatchList = arrOpenWatchlists[arrOpenWatchlists.length - 2];
            } else {
               // If deleteting watchlist at any other index then active is next watchlist
               objActiveWatchList = arrOpenWatchlists[nIndexOpenWatchlists + 1];
            }
         } else { }
      } else {
         // For no watchlist in open then active is blank
         objActiveWatchList = {};
      }

      if (nIndexOpenWatchlists >= 0) {
         arrOpenWatchlists.splice(nIndexOpenWatchlists, 1);
      }

      if (arrOpenWatchlists?.length === 0) {
         objActiveWatchList = {};
      }
      const nIndexWatchlist = arrWatchlists.findIndex((obj) => {
         return obj.id === watchlist?.id;
      });
      if (nIndexWatchlist >= 0) {
         arrWatchlists.splice(nIndexWatchlist, 1);
      } else { }

      return {
         status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS,
         data: { arrWatchlists, arrOpenWatchlists, objActiveWatchList }
      };
   } catch (error) {
      console.log(error);
      return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
   }
}


function parseQueryString(queryString) {
   const params = new URLSearchParams(queryString);
   if (params.has('token')) {
      const token = params.get('token');
      const ucc = params.get('ucc') ? params.get('ucc') : '';
      return { type: 'token', token, ucc };
   } else if (params.has('data')) {
      const data = params.get('data');
      return { type: 'data', data };
   }
}




/*BT-109369 Breeze- Watchlist- Share Watchlist This function stores query params from the url and sets into local storage as most of time if activeSession is not present it is redirected to login page --start  */
async function _storeQueryParams() {
   if (window.location.search) {
      let actionType = parseQueryString(window.location.search);
      if (actionType.type === 'data') {
         const strSearchParams = window.location.search.replace(/^\?data=/, "");
         const strData = TripleDESDecrypt(decodeURIComponent(strSearchParams));
         const strTenantId = JSON.parse(strData).tenantId;
         const pageToNavigate = JSON.parse(strData).navigate;
         const configTenantId = config?.TenantId;
         if (strTenantId === configTenantId) {
            setEncryptLocalStorage(DEEP_LINK, strData);
            if (getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION) !== null) {
               window.location.href = pageToNavigate;
            }
         }
      } else if (actionType.type === 'token') {
         if (config.Wave.ApiKey) {
            store.dispatch(userLogin(actionType.ucc, encryptTDES(COVER.TDES, actionType.token), 'TP_TOKEN', '', ''));
            store.dispatch(getUserDetials(actionType.ucc));
         } else {
            return;
         }

      }
   }

}
/*BT-109369 Breeze- Watchlist- Share Watchlist --end*/

/*BT-109369 Breeze- Watchlist- Share Watchlist --start*/
const _generateLink = (strWatchlistId, action, username) => {
   const objWatchlistData = {
      id: strWatchlistId,
      tenantId: config?.TenantId,
      navigate: 'watchlist',
   };

   if (username) {
      objWatchlistData.username = filterUsername(username);
   }



   const encrData = encodeURIComponent(TripleDESEncrypt(JSON.stringify(objWatchlistData)));
   const deepLinkURL = window?.origin + "?data=" + encrData;
   //Ameersha N - BT-109369 Breeze- Watchlist- Share Watchlist issue - Protocol has been added to link --start
   const mailtoLink = `mailto:?body= Hey there! Have a look at my Watchlist on BREEZE UAT ${deepLinkURL}`;

   //Ameersha N - BT-109369 Breeze- Watchlist- Share Watchlist issue - Protocol has been added to link --End
   if (action) {
      window.location.href = mailtoLink;
   } else {
      return deepLinkURL;
   }
};
/*BT-109369 Breeze- Watchlist- Share Watchlist --end*/





export {
   _storeQueryParams,
   _generateLink,
   _resetGridFeatures,
   _handleSystemDefinedWatchlist,
   _isWatchlistSystemDefined,
   _watchlistNameAlreadyExist,
   _allWatchlistOpened,
   _creatingCustomWatchlist,
   _checkForSpecialChars,
   _emptyWatchlist,
   _addingGlobalWatchlist,
   _filterWatchlistForSystemDefined,
   _renamingGlobalWatchlist,
   _removeSelectedScripts,
   _createAndAddScripsInWatchlist,
   _getAppDetailsByUser,
   _updateWatchlistandSetDefault,
   _getScripsInfo,
   _getDontMiss,
   _getScrips,
   _createWatchlist,
   _updateCurrentWatchlist,
   _updatingWatchlist,
   _getWhatsHotData,
};